export type HttpMethod = 'post' | 'get' | 'put' | 'delete' | 'patch'

export enum NamingStrategy {
  'snakeCase' = 'snake_case',
  'camelCase' = 'camelCase'
}
export type ParamsNamingStrategy = NamingStrategy.snakeCase | NamingStrategy.camelCase

export type HttpRequest = {
  url: string
  method: HttpMethod
  body?: unknown
  headers?: Partial<unknown>
  params?: Partial<unknown>
  withCredentials?: boolean
  paramsNamingStrategy?: ParamsNamingStrategy
  onUploadProgress?: (progressPercent: number) => void
  signal?: AbortSignal
  correlationId?: string
  responseType?: 'blob' | 'arraybuffer' | 'text' | 'json'
}

export type HttpResponseHeaders = { [key: string]: string | string[] | number | boolean | null }

export type HttpResponse<T = unknown | undefined> = {
  statusCode: number
  headers?: HttpResponseHeaders
  body?: T
  correlationId?: string
}

export interface HttpClient<R = unknown> {
  request: (data: HttpRequest) => Promise<HttpResponse<R>>
}

export enum HttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  multipleChoices = 300,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  unprocessableEntity = 422,
  conflict = 409,
  serviceUnavailable = 503,
  serverError = 500
}
